import { Port } from 'app/shared/model/Port';
import { FETCH_PORTS, SET_PORTS, UPSERT_PORT, UPSERT_TERMINAL } from './actions';

export interface PortState {
  ports: Port[];
  isLoading?: boolean;
}

const initialState: PortState = { ports: [], isLoading: false };

export default function portManagerReducer(state = initialState, action: any): PortState {
  switch (action.type) {
    case FETCH_PORTS:
      return { ...state, isLoading: true };

    case SET_PORTS:
      return { ...state, ports: action.payload, isLoading: false };

    case UPSERT_PORT: {
      const incoming = action.payload as Partial<Port>;
      const ports = [...state.ports];

      if (incoming.id != null) {
        // update existing
        const idx = ports.findIndex(p => p.id === incoming.id);
        if (idx >= 0) {
          ports[idx] = {
            ...ports[idx],
            ...incoming,
            terminals: incoming.terminals ?? ports[idx].terminals ?? [],
          };
          return { ...state, ports };
        }
      }
      // insert new
      const nextId = ports.length ? Math.max(...ports.map(p => p.id)) + 1 : 1;
      ports.push({
        id: nextId,
        name: incoming.name?.trim() || 'New Port',
        type: incoming.type || 'Airport',
        active: incoming.active ?? true,
        terminals: [],
        entityUpdate: incoming.entityUpdate ?? false,
      });
      ports.sort((a, b) => a.name.localeCompare(b.name));
      return { ...state, ports };
    }

    case UPSERT_TERMINAL: {
      const { portId, terminal } = action.payload as { portId: number; terminal: Partial<Port['terminals'][number]>; };
      const ports = state.ports.map(p => ({ ...p, terminals: [...(p.terminals ?? [])] }));
      const pIdx = ports.findIndex(p => p.id === portId);
      if (pIdx < 0) return state;

      const tNumber = Number(terminal.number ?? 1);
      const synthId = portId * 1000 + tNumber;

      const tIdx = ports[pIdx].terminals.findIndex(t => t.id === synthId || t.number === tNumber);

      const upserted = {
        id: synthId,
        name: String(terminal.name ?? '').trim(),
        number: tNumber,
        active: Boolean(terminal.active),
      };

      if (tIdx >= 0) {
        ports[pIdx].terminals[tIdx] = { ...ports[pIdx].terminals[tIdx], ...upserted };
      } else {
        ports[pIdx].terminals.push(upserted);
      }
      ports[pIdx].terminals.sort((a, b) => a.number - b.number);

      return { ...state, ports };
    }

    default:
      return state;
  }
}